import ConfigProvider from "@/shared/config-provider";
import { TranslationProviderProps } from "./types";
import dayjs from "dayjs";
import { messages } from "../constants/antd-messages";

export function AntTranslationProvider({
  children,
  locale,
}: TranslationProviderProps) {
  dayjs.locale(locale);

  return <ConfigProvider locale={messages[locale]}>{children}</ConfigProvider>;
}
